<template>
  <div class="goods-detail-item">
    <div class="detail-address" @click.deb="bindShowMemberAddress()">
      <dl class="item-address">
        <a href="javascript:;">
          <div class="item-name"><i></i></div>
          <div class="item-con">
            <dl>
              <dd v-if="currentFreigthInfo.allowSend && currenMemberAddress.areaId2">
                <!--<span class="color" data-name="現貨">ကုႏႅက္႐ြိ</span>-->
                {{freightAmountText}}
              </dd>
              <dd v-if="!currentFreigthInfo.allowSend && currenMemberAddress.areaId2" data-name="無貨">ပစၥၫ္းမ႐ြိေတာ႔ပါ</dd>
              <dt v-text="currenMemberAddress.areaInfo + currenMemberAddress.address"></dt>
            </dl>
          </div>
          <div class="item-more"></div>
        </a>
      </dl>
      <!--<dl class="item-address" v-show="currentFreigthInfo.freightWeight && currentFreigthInfo.allowSend">-->
      <!--<div class="item-name" data-name="重量">ေအလးခ္ိႏ္</div>-->
      <!--<div class="item-con">-->
      <!--<dl>-->
      <!--<dt>{{currentFreigthInfo.freightWeight}}kg</dt>-->
      <!--</dl>-->
      <!--</div>-->
      <!--</dl>-->

      <!--<dl class="item-address" v-show="currentFreigthInfo.freightVolume && currentFreigthInfo.allowSend">-->
      <!--<div class="item-name"data-name="體積">အျရယ္အစား</div>-->
      <!--<div class="item-con">-->
      <!--<dl>-->
      <!--<dt>{{currentFreigthInfo.freightVolume }}m<sub>3</sub></dt>-->
      <!--</dl>-->
      <!--</div>-->
      <!--</dl>-->
    </div>
    <!--移动到body下面-->
    <transition name="ncbottom">
      <div class="nctouch-bottom-mask mask-show" v-show="show" ref="layer">
        <!--<div class="nctouch-bottom-mask-bg" @click="bindCloseArea()" @touchmove="excludeTouch"></div>-->
        <div class="nctouch-bottom-mask-block">
          <div class="nctouch-bottom-mask-top" @touchmove="excludeTouch">
            <div class="close">
              <i class="closed" @click="show=false"></i>
              <i @click="showOther = false;" class="right" v-show="showOther && token" data-name="配送之"></i>ကုန္လက္ခံလိပ္စာ
            </div>
          </div>
          <!-- 地址1 Begin -->
          <div :class="['address-options',{'hide':showOther}]">
            <div class="address-content" ref="memberAddress">
              <ul>
                <li :class="['address-item',{'checked':currenMemberAddress.addressId == item.addressId }]"
                    v-for="(item , index )  in addressList" @click.stop="bindSelectMemberAddress(item)">
                  <i class="tick"></i>
                  <i class="location"></i>
                  <div class="address-options">{{item.areaInfo + " " + item.address}}</div>
                </li>
              </ul>
            </div>
            <div class="address-bottom green-btn"
                 @touchmove="excludeTouch"
                 @click.stop="bindShowOther()"
                 data-name="選擇其他地區"
            >အျခားလိပ္စာေရြးပါ
            </div>
          </div>
          <!-- End -->

          <!-- 地址2 选城市  Begin-->
          <div :class="['city-options',{'hide':!showOther}]">
            <div class="city-content">
              <dl class="city-select">
                <dd
                  v-for="(navItem ,navIndex)  in areaNavArray"
                  :class="{select:navIndex ==currentAreaIndex }"
                  @click="bindAreaNavSelect(navIndex)">{{navItem.areaName2}}
                </dd>
              </dl>
              <div class="city-select-panel" ref='swipe'>
                <ul :style="{width: width * areaContentArray.length + 'px'}">
                  <li v-for="(cItem , cIndex) in areaContentArray" :style="{width: width + 'px'}">
                    <div class="city-item-scroll" :id="'cityItem_' + cIndex">
                      <dl class="city-item">
                        <a href="javascript:;"
                           v-for="areaItem in  cItem"
                           @click="bindAreaSelect(areaItem,cIndex)"
                           :class="{checked:currentAreaInfo &&  currentAreaInfo.areaId==areaItem.areaId}">
                          <h4>{{areaItem.areaName}}</h4><i></i></a>
                      </dl>
                    </div>
                  </li>
                </ul>
              </div>

            </div>
          </div>
          <!-- End -->
        </div>
      </div>
    </transition>
    <!--end 移动到body下面-->
  </div>
</template>
<script>
  //    var ApiUrl = "https://my.zegobird.com:11101/api";

  //计算运费地址
  var urlFreight = ApiUrl + '/goods/calc/freight';
  //会员获取收货地址
  var urlMemberAddress = ApiUrl + '/member/address/list';
  //地区获取接口
  var urlAreaList = ApiUrl + '/area/list';
  //本地存储标识
  var localStorageKey = "goodsArea";
  var mySwipe, myIScroll,
    iscrollArray = []
  ;
  export default {
    //外部传入参数
    props: {
      max: {
        type: Number,
        default: 4
      },
      //token
      token: {
        type: String,
        required: false
      },
      //商品 commonid
      commonId: {
        type: Number,
        required: true
      },
      //购买数量
      buyNum: {
        type: Number,
        default: 1
      }
    },
    /*
     * 自身数据,一定要一个function
     */
    data: function () {
      return {
        //显示开关
        show: false,
        //显示其他
        showOther: false,
        //缓存会员地址
        addressList: [],
        //当前 会员地址信息
        currenMemberAddress: {
          addressId: 0,
          areaId2: 0,
          areaId3: 0,
          areaId4: 0,
          areaInfo: 'ကုန္လက္ခံလိပ္စာေရြးခ်ယ္ပါ',//请选择配送地区
          address: ''
        },
        //当前运费信息
        currentFreigthInfo: {
          //二级地址
          areaId2: 0,
          areaId3: 0,
          areaId4: 0,
          //是否有货 (1-有货,0-无货)
          allowSend: 0,
          //运费(无货时运费为0，不显示运费)
          freightAmount: 0,
          //重量
          freightWeight: 0,
          //体积
          freightVolume: 0
        },
        //地区选择导航数组
        areaNavArray: [{
          areaName: "  ေျရးခ္ယၸါ",//请选择
          areaName2:"တိုင္း",//省
          areaId: 0
        }],
        //地区列表数组
        areaContentArray: [],
        //当前选择的地区层级
        currentAreaIndex: 0,
        //当点击最后一级地区的时候不需要更新swipe
        //当初始化的时候改成false
        swipeNoSteup: false,
        //
        cancelWatchShow: false,
        //标识是否正在发送post
        isPosting: false
      }
    },
    /**
     * 计算属性
     */
    computed: {
      width: function () {
        return $(window).width()
      },

      //会员默认地址
      defaultMemberAddress: function () {
        if (!this.addressList.length) {
          var _storage = localStorage.getItem(localStorageKey);
          //获取本地数据
          if (_storage) {
            try {
              _storage = JSON.parse(_storage);
            } catch (e) {
              return null
            }
            return {
              addressId: 0,
              areaId2: _storage.areaId2,
              areaId3: _storage.areaId3,
              areaId4: _storage.areaId4,
              areaInfo: _storage.areaInfo,
              address: ''
            }
          }
          return null
        }
        return this.addressList.filter(function (item) {
          return item.isDefault == 1
        })[0] || this.addressList[0]
      },
      //运费
      freightAmountText: function () {  //预计运费为:                                //免运费
        return this.currentFreigthInfo.freightAmount ?  this.currentFreigthInfo.freightAmount + "Ks" : "ပို႔ခအခမဲ့"
      },
      //当前地区选择信息
      currentAreaInfo: function () {
        return this.areaNavArray[this.currentAreaIndex]
      }
    },

    /**
     * 监听属性变动
     */
    watch: {
      //监控是否地区选择
      showOther: function (newValue) {
        if (newValue) {
          this.initArea()
        }
      },
      //显示监控
      show: function (newValue) {
        var self = this
        if (newValue) {
          ( !this.token || !this.addressList.length) && (this.showOther = true )
          self.$nextTick(function () {
            //判断插件加载
            if (!myIScroll) {
              myIScroll = new IScroll(this.$refs.memberAddress, {
                scrollX: false,
                scrollY: true,
                click: true
              });
            }
          })
        } else {
          this.cancelWatchShow || ( this.showOther = newValue )
          this.cancelWatchShow = false;
        }
      }
    },
    /**
     * 过滤器
     */
    filters: {},
    /**
     * 生命周期钩子
     */
    created: function () {

      if (this.token) {
        this.initLogined()
      } else {
        this.initNologin();
      }
    },

    mounted() {

      var $layer = this.$refs.layer;
      var $body = document.getElementsByTagName("body")[0];
      $body.appendChild($layer);
    },
    /**
     * 自定义方法
     */
    methods: {
      //去除无关的touch事件
      excludeTouch: function (event) {
        event.preventDefault();
        return false;
      },
      //未登录的初始化
      initNologin: function () {

        var _storage = localStorage.getItem(localStorageKey);
        //获取本地数据
        if (_storage) {
          try {
            _storage = JSON.parse(_storage);
          } catch (e) {
            this.currenMemberAddress.addressId = 0
            this.currenMemberAddress.areaId2 = 0
            this.currenMemberAddress.areaId3 = 0
            this.currenMemberAddress.areaId4 = 0
            this.currenMemberAddress.areaInfo = 'ကုန္လက္ခံလိပ္စာေရြးခ်ယ္ပါ'//请选择配送地区
            this.currenMemberAddress.address = ''
            return
          }
          this.currenMemberAddress.addressId = 0
          this.currenMemberAddress.areaId2 = _storage.areaId2;
          this.currenMemberAddress.areaId3 = _storage.areaId3;
          this.currenMemberAddress.areaId4 = _storage.areaId4;
          this.currenMemberAddress.areaInfo = _storage.areaInfo;
          this.currenMemberAddress.address = ''
          //计算运费
          this.getFreight(_storage.areaId2, _storage.areaId3, _storage.areaId4);
        } else {
          this.currenMemberAddress.addressId = 0
          this.currenMemberAddress.areaId2 = 0
          this.currenMemberAddress.areaId3 = 0
          this.currenMemberAddress.areaId4 = 0
          this.currenMemberAddress.areaInfo = 'ကုန္လက္ခံလိပ္စာေရြးခ်ယ္ပါ'//请选择配送地区
          this.currenMemberAddress.address = ''
        }
      },
      //登录后的初始化
      initLogined: function () {
        var self = this
        $.post(urlMemberAddress, {
          token: self.token
        }, function (xhr) {
          var str = JSON.stringify(xhr);
          var my = Rabbit.uni2zg(str);
          xhr = JSON.parse(my);
          if (xhr.code == 200) {
            self.addressList = xhr.datas.addressList || [];
            console.log(self.addressList);
            if (self.defaultMemberAddress) {
              self.currenMemberAddress.addressId = self.defaultMemberAddress.addressId
              self.currenMemberAddress.areaId2 = self.defaultMemberAddress.areaId2
              self.currenMemberAddress.areaId3 = self.defaultMemberAddress.areaId3
              self.currenMemberAddress.areaId4 = self.defaultMemberAddress.areaId4
              self.currenMemberAddress.areaInfo = self.defaultMemberAddress.areaInfo
              self.currenMemberAddress.address = self.defaultMemberAddress.address
              //手动调去运费信息
              self.getFreight(self.currenMemberAddress.areaId2, self.currenMemberAddress.areaId3, self.currenMemberAddress.areaId4);
            }
          }
        })
      },
      //获取运费
      getFreight: function (areaId2, areaId3 , areaId4) {
        var self = this
        $.post(urlFreight, {
          commonId: self.commonId,
          buyNum: self.buyNum,
          areaId2: areaId2
        }, function (xhr) {
          if (xhr.code == 200) {
            let _data = xhr.datas;
            console.log(_data)
            self.currentFreigthInfo.areaId2 = areaId2;
            self.currentFreigthInfo.areaId3 = areaId3;
            self.currentFreigthInfo.areaId4 = areaId4;
            console.log(self.currentFreigthInfo)
            self.currentFreigthInfo.allowSend = _data.allowSend;
            self.currentFreigthInfo.freightAmount = _data.freightAmount;
            self.currentFreigthInfo.freightWeight = _data.freightWeight;
            self.currentFreigthInfo.freightVolume = _data.freightVolume;
            self.currentFreigthInfo.areaInfo = self.currenMemberAddress.areaInfo;
            self.$emit("freightend", self.currentFreigthInfo);

            self.$nextTick(function () {

              self.$emit("refresh")
            })
          }
        })
      },
      //初始化地区
      initArea: function () {
        var self = this

        $.get(urlAreaList, {
          areaId: 0
        }, function (xhr) {
          var str = JSON.stringify(xhr);
          var my = Rabbit.uni2zg(str);
          xhr = JSON.parse(my);
          if (xhr.code == 200) {
            self.currentAreaIndex = 0;
            self.areaNavArray.splice(0, self.areaNavArray.length, {
              areaName2: "တိုင္း",//省
              areaId: 0
            });
            self.areaContentArray.splice(0, self.areaContentArray.length, xhr.datas.areaList)


            self.setupSwipe()
            self.slideToSwipe(0)
          }
        })
      },
      //获取地区列表
      loadAreaList: function (areaId) {
        var self = this;
        if (this.isPosting) {
          return
        }
        this.isPosting = true
        $.get(urlAreaList, {
          areaId: areaId
        }, function (xhr) {
          var str = JSON.stringify(xhr);
          var my = Rabbit.uni2zg(str);
          xhr = JSON.parse(my);
          if (xhr.code == 200) {
            // self.areaNavArray.push({
            //   areaName: "  ေျရးခ္ယၸါ",//请选择
            //   areaId: 0
            // });
            self.areaContentArray.push(xhr.datas.areaList)
            self.setupSwipe();
            self.slideToSwipe(self.currentAreaIndex)
          } else {

            //地区选择完成
            self.areaSelectEnd();
          }
        }).always(function () {
          self.isPosting = false
        })
      },
      //地区选择结束
      areaSelectEnd: function () {
        var _areaId2 = this.areaNavArray[1] ? this.areaNavArray[1].areaId : 0,
          _areaId3 = this.areaNavArray[2] ? this.areaNavArray[2].areaId : 0,
          _areaId4 = this.areaNavArray[3] ? this.areaNavArray[3].areaId : 0,
          _areaInfo = this.areaNavArray.map(function (value) {
            return value.areaName
          }).join(" ");
        this.currenMemberAddress = {}
        this.currenMemberAddress.areaId2 = _areaId2
        this.currenMemberAddress.areaId3 = _areaId3
        this.currenMemberAddress.areaId4 = _areaId4
        this.currenMemberAddress.areaInfo = _areaInfo
        this.currenMemberAddress.addressId = 0;
        this.currenMemberAddress.address = "";
        //写入本地存储
        localStorage.setItem(localStorageKey, JSON.stringify({
          areaId2: _areaId2,
          areaId3: _areaId3,
          areaId4: _areaId4,
          areaInfo: _areaInfo
        }));
        //手动调去运费信息
        this.getFreight(_areaId2, _areaId3 , _areaId4);
        //关闭地址选择
        this.bindCloseArea();
      },
      //手动刷新swipe
      setupSwipe: function () {
        var self = this
        this.$nextTick(function () {

          var _currentIndex = self.currentAreaIndex > 0 ? self.currentAreaIndex - 1 : 0;
          if (mySwipe) {
            mySwipe.refresh()
            return
          }
          mySwipe = new IScroll(this.$refs.swipe, {
            scrollX: true,
            scrollY: false,
            momentum: false,
            snap: true,
            snapSpeed: 400,
            click: true,
            bounce: false,
            excludeElement: "scroll-exclude",
            snapCallBack: function (pageX, pageY) {

              self.currentAreaIndex = pageX
            }
          });
        })
      },
      //地区swipe滚动到
      slideToSwipe: function (index, retain) {
        this.$nextTick(function () {
          mySwipe.goToPage(index, 0)

          if (retain) return
          if (iscrollArray[index]) {
            iscrollArray[index].destroy();
          }
          iscrollArray[index] = new IScroll("#cityItem_" + index, {
            scrollX: false,
            scrollY: true,
            click: false
          });

        })
      },
      //显示会员的地址选择
      bindShowMemberAddress: function () {
        ga('send', 'event', '选择地址按钮', '点击', '按钮点击'); //谷歌锚点
        this.show = true;
      },
      //显示地区
      bindShowOther: function () {
        this.showOther = true;
      },
      //会员点击收货地址
      bindSelectMemberAddress: function (addressInfo) {

        if (addressInfo == this.currenMemberAddress.addressId) return;
        //设置为当前选择的地址
        this.currenMemberAddress = addressInfo;
        //手动获取运费
        this.getFreight(addressInfo.areaId2, addressInfo.areaId3 , addressInfo.areaId4)
        //关闭地址选择
        this.show = false;

      },
      //地区列表中的地区选择
      bindAreaSelect: function (areaInfo, index) {

        if (this.currentAreaInfo && this.currentAreaInfo.areaId == areaInfo.areaId) return;

        this.currentAreaIndex = index + 1
        if(this.currentAreaIndex==1){
          this.areaNavArray.splice(index, this.areaNavArray.length, {
            areaName: areaInfo.areaName,
            areaName2:"တိုင္း",
            areaId: areaInfo.areaId
          })
          this.areaNavArray.push({
            areaName2:"ခရိုင္"
          })
        }
        else if(this.currentAreaIndex==2){
          this.areaNavArray.splice(index, this.areaNavArray.length, {
            areaName: areaInfo.areaName,
            areaName2:"ခရိုင္",
            areaId: areaInfo.areaId
          })
          this.areaNavArray.push({
            areaName2:"ၿမိဳ႕နယ္"
          })
        }
        else if(this.currentAreaIndex==3){
          this.areaNavArray.splice(index, this.areaNavArray.length, {
            areaName: areaInfo.areaName,
            areaName2:"ၿမိဳ႕နယ္",
            areaId: areaInfo.areaId
          })
          this.areaNavArray.push({
            areaName2:"ၿမိဳ႕"
          })
        }
        else if(this.currentAreaIndex==4){
          this.areaNavArray.splice(index, this.areaNavArray.length, {
            areaName: areaInfo.areaName,
            areaName2:"ၿမိဳ႕",
            areaId: areaInfo.areaId
          })

        }
        // this.areaNavArray.splice(index, this.areaNavArray.length, {
        //     areaName: areaInfo.areaName,
        //     areaId: areaInfo.areaId
        // })
        this.areaContentArray.splice(index + 1);
        console.log(this.max);
        // this.areaNavArray.splice(index, this.areaNavArray.length, {
        //   areaName: areaInfo.areaName,
        //   areaId: areaInfo.areaId
        // })
        this.areaContentArray.splice(index + 1)

        if (this.areaContentArray.length >= this.max) {
          this.areaSelectEnd();
        } else {
          this.loadAreaList(areaInfo.areaId)
        }
      },
      //地区导航点击
      bindAreaNavSelect: function (navIndex) {
        this.currentAreaIndex = navIndex
        this.slideToSwipe(navIndex, true)
      },
      //点击关闭地区
      bindCloseArea: function () {
        var self = this;
        this.cancelWatchShow = true;
        this.show = false

        setTimeout(function () {
          self.showOther = false

        }, 300)

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/goods-area-select/goods-area-select.vue